import Description from "@/components/frontend/ui/form/inputs/description";
import FieldError from "@/components/frontend/ui/form/inputs/field-error";
import Label from "@/components/frontend/ui/form/inputs/label";
import { Toggle, ToggleGroup } from "@/components/frontend/ui/toggle-group";
import { cn } from "@/lib/utils";
import { type FormToggleGroupBlock as FormToggleGroupBlockT } from "@/payload-types";
import { useId } from "react";

type FormToggleGroupBlockProps = FormToggleGroupBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
};

export const FormToggleGroupBlock: React.FC<FormToggleGroupBlockProps> = ({
	content,
	options,
	settings,
	style,
	containerClassName,
	fieldValue,
	fieldError,
	onFieldChange,
}) => {
	const legendId = useId();

	return (
		<div className={cn("flex flex-col items-start gap-2", containerClassName)}>
			{content?.label && (
				<Label variant="legend" id={legendId} required={content.required ?? false} visible={!settings?.hideLabel}>
					{content.label}
				</Label>
			)}

			<ToggleGroup
				variant={style?.toggleGroupVariant ?? "default"}
				multiple={false}
				orientation={settings?.orientation === "vertical" ? "vertical" : "horizontal"}
				value={typeof fieldValue === "string" && fieldValue.length > 0 ? ([fieldValue] as [string]) : ([] as string[])}
				onValueChange={(groupValue) => {
					if (content?.required && groupValue.length === 0) {
						return;
					}
					onFieldChange?.(groupValue[0] ?? "");
				}}
				aria-labelledby={content?.label ? legendId : undefined}
				className="w-full"
			>
				{(options ?? []).map((option: { label: string; value: string }) => (
					<Toggle key={option.value} value={option.value}>
						{option.label}
					</Toggle>
				))}
			</ToggleGroup>

			{content?.description && <Description>{content.description}</Description>}
			<FieldError message={fieldError} />
		</div>
	);
};
